import React from "react";

import useAdminForms from "../hooks/useAdminForms";
import AdminForms from "../components/AdminForms";

const AdminFormsInterface = function (props) {
  const { onEdit, canEdit } = props;
  const {
    forms,
    superUser,
    onDelete,
    onRefreshData,
    onExportData,
    apiError,
    search,
  } = useAdminForms(props);

  return (
    <AdminForms
      superUser={superUser}
      forms={forms}
      onEdit={onEdit}
      canEdit={canEdit}
      onDelete={onDelete}
      apiError={apiError}
      onRefreshData={onRefreshData}
      onExportData={onExportData}
      search={search}
    />
  );
};

export default AdminFormsInterface;
